'use client';
import styled from 'styled-components';

export const Subheadline = styled.p`
  margin: 0 auto;
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};

  @media ${({ theme }) => theme.tablet} {
    padding: ${props => props.theme.spacing(2)} 0
      ${props => props.theme.spacing(4, 4, 0, 4)};
  }
`;

export const IconContainer = styled.div`
  padding: ${props => props.theme.spacing(0, 1)};
  height: 24px;
`;

export const RecipeText = styled.div`
  margin-left: ${props => props.theme.spacing(1)};
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;

export const DidYouKnowTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  background-color: ${props => props.theme.colors.secondary.chia};
  color: ${props => props.theme.colors.background.lightest};
  padding: ${props => props.theme.spacing(1)};
  ${props => props.theme.typography.subheading2};
  border-radius: 32px;
  margin: ${props => props.theme.spacing(0, 10, 5, 10)};
  max-width: 360px;
  text-transform: uppercase;
`;

export const TextOnlyContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: ${props => props.theme.spacing(1)};
  width: 100%;
`;

export const HeadlineText = styled.div`
  width: 100%;
  ${props => props.theme.typography.subheading1};
  color: ${props => props.theme.colors.text.primary};
`;

export const SubheadlineTextOnly = styled.div`
  width: 100%;
  ${props => props.theme.typography.subheading2};
  color: ${props => props.theme.colors.background.lightest};
`;

export const ImageContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const Container = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background.base};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing(3)};

  @media ${props => props.theme.laptop} {
    margin-top: ${props => props.theme.spacing(8)};
    padding-top: ${props => props.theme.spacing(2)};
    margin-bottom: ${props => props.theme.spacing(8)};
  }
`;

export const ArrowButtonContainer = styled.div`
  display: flex;
  position: fixed;
  top: 96px;
  left: 10px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
  button {
    background-color: #37332db2;
    border: none;
  }
`;

export const PillContainer = styled.div`
  margin: ${props => props.theme.spacing(3, 'auto')};
  padding-bottom: ${props => props.theme.spacing(2)};
  text-transform: uppercase;
`;
